export default {
  DISTANCE: 1,
  MASL: 2,
  UNIT: 3,
  PPH: 4,
  BOOLYES: 5,
  BOOLNO: 6,
};



// WEBPACK FOOTER //
// ./src/variables/unitTypes.js